import React from 'react'
import { ReactComponent as CaretDownIcon } from '../../assets/svg/CaretDownIcon.svg'

function ExpandButton({ open, onClick, width = 40, height = 40, backgroundColor = '#ECEBF8', id }) {
    return (
        <button
            className={`flex items-center justify-center rounded-full  ${open ? 'rotate-0 ' : 'rotate-180 '} transition`}
            onClick={onClick}
            style={{ width, height, backgroundColor }}
            id={id}
        >
            <CaretDownIcon />
        </button>
    )
}

export default ExpandButton
